const CONFIG = {
  DATAORDER: "DATA_ORDER_STORAGE",
};

export default CONFIG;
